import SignOutSvg from "@/icons/sign-out.svg";
import { useAddReferrals } from "@/modules/shared/hooks/use-add-referrals";

import "./add-referrals.scss";

const AddReferrals = () => {
  const { addReferrals } = useAddReferrals();

  if (import.meta.env.VITE_DEBUG !== "true") return null;

  return (
    <button className="add-referrals" onClick={addReferrals}>
      <SignOutSvg />
    </button>
  );
};

export { AddReferrals };
